/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'walking': {
    width: 16,
    height: 16,
    viewBox: '0 0 40.39 66',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M23.54.5a6.64 6.64 0 1 0 6.67 6.64A6.65 6.65 0 0 0 23.54.5zm.22 41.33l-2.38-3.69 1.27-5.29.93-3.85 1.94-8.08a4.24 4.24 0 0 0-4.07-5.16h-1.76a14.61 14.61 0 0 0-6.53 1.57c-4 2.2-6.63 4.19-8.29 6.95-2 3.27-2.15 7-2.13 12.06a2.61 2.61 0 1 0 5.26.03v-.08c0-4.92.27-7.5 1.39-9.35.85-1.42 2.43-2.79 5.4-4.53l-2.4 11.45-.2 1a4.66 4.66 0 0 0 .71 3.83l4.53 7 1.28 2L29 63.75a3.72 3.72 0 0 0 6.32-3.95l-.06-.09-6.5-10.08m-1.93-25.7L25.17 31l.25.25c2.72 2.67 6.28 3.71 11.23 4.87a2.61 2.61 0 1 0 1.26-5.06h-.07c-4.79-1.13-7.23-2-8.78-3.52a20.82 20.82 0 0 1-2.19-3.61zM8.81 50.79l-7.36 8.5a3.72 3.72 0 1 0 5.56 5l.07-.08 8-9.25a3.72 3.72 0 0 0 .84-1.72l.9-4.63-5.71-8.85z" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/walking.js